import { type Context, createContext } from 'react';

import {
  FilterBarContextProps,
  FilterState,
} from '../types/shared-filter-types.js';

export const initialState: FilterState = { filters: {}, itemsPinnedState: {} };

/** FilterBar context, used to access the state and dispatcher in other components. */
export const FilterBarContext: Context<FilterBarContextProps> =
  createContext<FilterBarContextProps>({
    state: initialState,
    showLabels: true,
    lastAddedItem: null,
    setLastAddedItem: (value) => null,
    dispatch: () => null,
    hasControlledPinnedState: false,
  });
